export const GET_USER_ACTIVITY_LOGS = 'GET_USER_ACTIVITY_LOGS'
export const GET_USER_ACTIVITY_LOGS_INDICATOR = 'GET_USER_ACTIVITY_LOGS_INDICATOR'

export const GET_USER_ACTIVITY_LOG = 'GET_USER_ACTIVITY_LOG'
export const GET_USER_ACTIVITY_LOG_INDICATOR = 'GET_USER_ACTIVITY_LOG_INDICATOR'


